// extracted by mini-css-extract-plugin
module.exports = {"page":"BookADemo_page__FG3qx","container":"BookADemo_container__2Ra_x"};